module.exports = __webpack_public_path__ + "static/media/avatar_whale.c3a0ebaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_whale.png
// module id = 401
// module chunks = 0